import React, { useEffect, useState } from "react";


import {
    isCreditCard, isIBAN
} from "validator";


import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";

import {
    ButtonComponent
} from "@Components/Forms";


import {
    DefaultPopupComponent,
    DropdownFieldComponent, DropdownFieldOptionInterface,
    InputFieldComponent,
    FormFieldStatusInterface,
} from "@Elements";


import IconBankAccountSmGrey from "@Pages/@@UserPages/@@Dashboard/@Wallet/@Icons/icon-bank-sm-grey.svg";
import IconCreditCardSmGrey from "@Pages/@@UserPages/@@Dashboard/@Wallet/@Icons/icon-credit_card-sm-grey.svg";
import IconLockXsGrey from "@Pages/@@UserPages/@@Dashboard/@Wallet/@Icons/icon-lock-xs-grey.svg";


import "./index.scss";


const AddNewAccountDropdownOptions:DropdownFieldOptionInterface[] = [
    {
        optionId: 0,
        optionText: "- Choose -",
    },
    {
        optionId: 1,
        optionText: "Credit Card",
        optionIconLeft: IconCreditCardSmGrey
    },
    {
        optionId: 2,
        optionText: "Bank Account",
        optionIconLeft: IconBankAccountSmGrey
    },
];


interface UserDashboardWalletAddNewAccountComponentProps {
    popupCloseCallback: () => void;
}


export const UserDashboardWalletAddNewAccountComponent:React.FC<UserDashboardWalletAddNewAccountComponentProps> = ({
    popupCloseCallback
}) => {


    const [addNewWithdrawAccountType, setAddNewWithdrawAccountType] = useState<number | string>(0);
    const [addNewWithdrawAccountAccountNumber, setAddNewWithdrawAccountAccountNumber] = useState('');
    const [addNewWithdrawAccountHolderFirstName, setAddNewWithdrawAccountHolderFirstName] = useState('');
    const [addNewWithdrawAccountHolderLastName, setAddNewWithdrawAccountHolderLastName] = useState('');

    const [addNewWithdrawAccountTypeStatus, setAddNewWithdrawAccountTypeStatus] = useState<FormFieldStatusInterface | null>(null);
    const [addNewWithdrawAccountAccountNumberStatus, setAddNewWithdrawAccountAccountNumberStatus] = useState<FormFieldStatusInterface | null>(null);
    const [addNewWithdrawAccountHolderFirstNameStatus, setAddNewWithdrawAccountHolderFirstNameStatus] = useState<FormFieldStatusInterface | null>(null);
    const [addNewWithdrawAccountHolderLastNameStatus, setAddNewWithdrawAccountHolderLastNameStatus] = useState<FormFieldStatusInterface | null>(null);

    useEffect(() => {
        return () => {
            setAddNewWithdrawAccountType(0);
            setAddNewWithdrawAccountAccountNumber('');
            setAddNewWithdrawAccountHolderFirstName('');
            setAddNewWithdrawAccountHolderLastName('');
            setAddNewWithdrawAccountTypeStatus(null);
            setAddNewWithdrawAccountAccountNumberStatus(null);
            setAddNewWithdrawAccountHolderFirstNameStatus(null);
            setAddNewWithdrawAccountHolderLastNameStatus(null);
        };
    }, []);

    const changeNewWithdrawAccountType = (optionId: number | string) => {
        if (optionId !== 0 && addNewWithdrawAccountTypeStatus?.statusType === 'error') {
            setAddNewWithdrawAccountTypeStatus(null);
        }
        setAddNewWithdrawAccountType(optionId);
    };

    const changeAddNewWithdrawAccountAccountNumber = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        if (addNewWithdrawAccountType === 1) {
            if (isCreditCard(fieldValue) && addNewWithdrawAccountAccountNumberStatus?.statusType === 'error') {
                setAddNewWithdrawAccountAccountNumberStatus(null);
            }
        } else if (addNewWithdrawAccountType === 2) {
            if (isIBAN(fieldValue) && addNewWithdrawAccountAccountNumberStatus?.statusType === 'error') {
                setAddNewWithdrawAccountAccountNumberStatus(null);
            }
        }
        setAddNewWithdrawAccountAccountNumber(fieldValue);
    };

    const changeAddNewWithdrawAccountHolderFirstName = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        if (fieldValue.length > 1 && addNewWithdrawAccountHolderFirstNameStatus?.statusType === 'error') {
            setAddNewWithdrawAccountHolderFirstNameStatus(null);
        }
        setAddNewWithdrawAccountHolderFirstName(fieldValue);
    };

    const changeAddNewWithdrawAccountHolderLastName = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        if (fieldValue.length > 1 && addNewWithdrawAccountHolderLastNameStatus?.statusType === 'error') {
            setAddNewWithdrawAccountHolderLastNameStatus(null);
        }
        setAddNewWithdrawAccountHolderLastName(fieldValue);
    };


    const addNewAccountSubmitHandler = () => {

        let error = false;

        if (addNewWithdrawAccountType === 0) {
            error = true;
            setAddNewWithdrawAccountTypeStatus({ statusType: 'error', statusMessage: 'You need to choose account type' });
        }

        if (addNewWithdrawAccountType === 1) {
            if (!isCreditCard(addNewWithdrawAccountAccountNumber)) {
                error = true;
                setAddNewWithdrawAccountAccountNumberStatus({ statusType: 'error', statusMessage: 'Wrong card number' })
            }
        } else if (addNewWithdrawAccountType === 2) {
            if (!isIBAN(addNewWithdrawAccountAccountNumber)) {
                error = true;
                setAddNewWithdrawAccountAccountNumberStatus({ statusType: 'error', statusMessage: 'Wrong IBAN number' })
            }
        }

        if (addNewWithdrawAccountHolderFirstName.length < 2) {
            error = true;
            setAddNewWithdrawAccountHolderFirstNameStatus({ statusType: 'error', statusMessage: 'First Name is required.' });
        }

        if (addNewWithdrawAccountHolderLastName.length < 2) {
            error = true;
            setAddNewWithdrawAccountHolderLastNameStatus({ statusType: 'error', statusMessage: 'Last Name is required.' });
        }

        if (error) {
            return;
        }

    };


    const addNewAccountRequestHandler = () => {



    };


    return (
        <DefaultPopupComponent
            popupHeader={'Add an account'}
            popupCloseCallback={popupCloseCallback}
        >

            <Col xs={12} className={'user-wallet-add-card-popup-content'}>
                <Row className={'user-wallet-add-card-popup-content__popup-content'}>

                    <DropdownFieldComponent
                        dropdownFieldOptions={AddNewAccountDropdownOptions} dropdownFieldOptionSelected={addNewWithdrawAccountType}
                        dropdownFieldLabel={'Account Type'} dropdownFieldRequiredStatus={true}
                        dropdownFieldOnChangeCallback={changeNewWithdrawAccountType}
                        dropdownFieldStatus={addNewWithdrawAccountTypeStatus}
                    />

                    <InputFieldComponent
                        inputFieldLabel={'Account Number'} inputFieldRequiredStatus={true}
                        inputFieldValue={addNewWithdrawAccountAccountNumber} inputFieldValueHandler={changeAddNewWithdrawAccountAccountNumber}
                        inputFieldStatus={addNewWithdrawAccountAccountNumberStatus}
                    />

                    <InputFieldComponent
                        inputFieldLabel={'First Name'} inputFieldRequiredStatus={true}
                        inputFieldValue={addNewWithdrawAccountHolderFirstName} inputFieldValueHandler={changeAddNewWithdrawAccountHolderFirstName}
                        inputFieldStatus={addNewWithdrawAccountHolderFirstNameStatus}
                    />

                    <InputFieldComponent
                        inputFieldLabel={'Last Name'} inputFieldRequiredStatus={true}
                        inputFieldValue={addNewWithdrawAccountHolderLastName} inputFieldValueHandler={changeAddNewWithdrawAccountHolderLastName}
                        inputFieldStatus={addNewWithdrawAccountHolderLastNameStatus}
                    />

                    <Col xs={12} className={'button-field-component'}>
                        <ButtonComponent
                            text={'Save'} callback={addNewAccountSubmitHandler}
                        />
                    </Col>

                    <Col xs={12} className={'legend-field-component'}>
                        <Row className={'legend-field-component__field-content'}>
                            <Col xs={1} className={'legend-field-component__legend-icon'}>
                                <SvgIconComponent iconSource={IconLockXsGrey} />
                            </Col>
                            <Col xs={11} className={'legend-field-component__legend-text'}>
                                <span>
                                    All payment info is encrypted and stored securely by XYZ.<br/>
                                    We do not store your payment info on our servers.
                                </span>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Col>

        </DefaultPopupComponent>
    )

};


export default UserDashboardWalletAddNewAccountComponent;
